import { combineReducers } from 'redux';

import { kidsReducer } from './kids/kids.reducer';
import { adultsReducer } from './adults/adults.reducer';

export default combineReducers({
  kids: kidsReducer,
  adults: adultsReducer,
});
